module.exports = __webpack_public_path__ + "img/hr-branch-particle-20.2e2c01af.png";